import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=c519ab14&"
import script from "./Allocation.vue?vue&type=script&lang=ts&"
export * from "./Allocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports